import React from 'react';

import { useCurrentUserPermissions, useCurrentUserStaff } from 'src/hooks/user';

import { useVerifierById } from './useVerifierById';

export const useCurrentUserVerifier = () => {
  const { verifierStaff } = useCurrentUserStaff();
  const { hasVerifierRoles } = useCurrentUserPermissions();

  const verifierId = React.useMemo(() => {
    if (!hasVerifierRoles) return null;
    return verifierStaff?.verifier.id;
  }, [hasVerifierRoles, verifierStaff?.verifier.id]);

  return useVerifierById(verifierId);
};
